<template>
  <div class="pagination-info">
      <div class="pages">
          Página {{ value.current_page }} de {{ value.last_page }}
      </div>
      <div class="total">
          Exibindo {{  value.data.length }} de {{ value.total }}
      </div>
  </div>
</template>

<script>
export default {
    props: {
        value: Object,
    }
}
</script>

<style scoped lang="scss">

// Apagar para ficar a cor do clienteem outros branchs

.pagination-info{
    display: flex;
    padding: 1rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
    // box-shadow: 0 4px 4px #bbb;
    font-size: 1.3rem;
    color: var(--color-primary);
    // background-color: #fff;

    .pages{
        flex: 1;
    }

    .total{
        text-align: right;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination/PaginationInfo.vue